// File: baseEditor.js
import { initHtmlExporter }    from './htmlExporter.js';
import { initInvestmentEditor } from './investmentEditor.js';

export const Editor = {
  isEditing: false,
  listeners: [],
  onModeChange(fn) {
    console.log('[Editor] onModeChange: listener added');
    this.listeners.push(fn);
  },
  setEditing(mode) {
    console.log('[Editor] setEditing →', mode);
    this.isEditing = mode;
    this.listeners.forEach(fn => {
      try { fn(mode); }
      catch (err) { console.error('[Editor] listener error:', err); }
    });
  }
};

export function initBaseEditor() {
  console.log('[baseEditor] init start');

  const toolbar = document.createElement('div');
  toolbar.id = 'editor-toolbar';
  Object.assign(toolbar.style, {
    position:     'absolute',
    display:      'none',
    padding:      '4px',
    background:   'rgba(0,0,0,0.75)',
    borderRadius: '4px',
    zIndex:       '10001'
  });
  document.body.appendChild(toolbar);

  const btnCloneUp   = document.createElement('button');
  btnCloneUp.id      = 'tb-clone-up'; btnCloneUp.textContent = '⤒'; btnCloneUp.title = 'Clone Up';
  const btnCloneDown = document.createElement('button');
  btnCloneDown.id    = 'tb-clone-down'; btnCloneDown.textContent = '⤓'; btnCloneDown.title = 'Clone Down';
  const btnCloneLeft = document.createElement('button');
  btnCloneLeft.id    = 'tb-clone-left'; btnCloneLeft.textContent = '←'; btnCloneLeft.title = 'Clone Left';
  const btnCloneRight= document.createElement('button');
  btnCloneRight.id   = 'tb-clone-right'; btnCloneRight.textContent = '→'; btnCloneRight.title = 'Clone Right';
  const btnDelete    = document.createElement('button');
  btnDelete.id       = 'tb-delete'; btnDelete.textContent = '✕'; btnDelete.title = 'Delete';
  toolbar.append(btnCloneUp, btnCloneDown, btnCloneLeft, btnCloneRight, btnDelete);

  const editBtn = document.createElement('button');
  editBtn.id = 'editor-toggle-edit'; editBtn.type = 'button'; editBtn.textContent = 'Edit';
  Object.assign(editBtn.style, { position:'fixed', top:'1rem', right:'1rem', padding:'0.5rem 1rem', background:'#00CCFF', color:'#fff', border:'none', borderRadius:'4px', cursor:'pointer', zIndex:'10000' });
  document.body.appendChild(editBtn);

  const exportBtn = document.createElement('button');
  exportBtn.id = 'editor-export-html'; exportBtn.type = 'button'; exportBtn.textContent = 'Export HTML';
  Object.assign(exportBtn.style, { position:'fixed', top:'4rem', right:'1rem', padding:'0.5rem 1rem', background:'#00CCFF', color:'#fff', border:'none', borderRadius:'4px', cursor:'pointer', zIndex:'10000' });
  document.body.appendChild(exportBtn);

  const selected = new Set();
  function clearSelection() {
    selected.forEach(el => el.style.outline = '');
    selected.clear();
  }

  function updateToolbarPosition(el) {
    const rect = el.getBoundingClientRect();
    toolbar.style.top    = (window.scrollY + rect.top - toolbar.offsetHeight - 8) + 'px';
    toolbar.style.left   = (window.scrollX + rect.left) + 'px';
    toolbar.style.display = selected.size ? 'block' : 'none';
  }

  function selectHandler(e) {
    if (!Editor.isEditing) return;
    const forbidden = new Set([editBtn, exportBtn, btnCloneUp, btnCloneDown, btnCloneLeft, btnCloneRight, btnDelete]);
    if (forbidden.has(e.target)) return;
    e.preventDefault(); e.stopPropagation();
    const block = e.target.closest('li, tr, section, .section, table, div') || e.target;
    if (!e.ctrlKey) clearSelection();
    if (selected.has(block)) {
      block.style.outline = ''; selected.delete(block);
    } else {
      selected.add(block); block.style.outline = '2px solid red';
    }
    updateToolbarPosition(block);
  }

  function cloneSelected(direction) {
    if (!selected.size) return;
    selected.forEach(el => {
      const clone = el.cloneNode(true);
      if ((direction === 'left' || direction === 'right') && (el.tagName === 'TD' || el.tagName === 'TH')) {
        const row = el.parentNode;
        if (direction === 'left') row.insertBefore(clone, el);
        else row.insertBefore(clone, el.nextSibling);
      } else {
        if (direction === 'up')      el.parentNode.insertBefore(clone, el);
        else if (direction === 'down') el.parentNode.insertBefore(clone, el.nextSibling);
        else                          el.parentNode.insertBefore(clone, el.nextSibling);
      }
    });
  }
  function deleteSelected() {
    if (!selected.size) return;
    selected.forEach(el => el.remove());
    clearSelection(); toolbar.style.display = 'none';
  }

  btnCloneUp.addEventListener('click', () => cloneSelected('up'));
  btnCloneDown.addEventListener('click', () => cloneSelected('down'));
  btnCloneLeft.addEventListener('click', () => cloneSelected('left'));
  btnCloneRight.addEventListener('click', () => cloneSelected('right'));
  btnDelete.addEventListener('click', deleteSelected);

  document.addEventListener('keydown', e => {
    if (!Editor.isEditing) return;
    if (e.key === 'Delete')      { deleteSelected(); e.preventDefault(); }
    if (e.ctrlKey && e.key === 'e'){ editBtn.click(); e.preventDefault(); }
    if (e.ctrlKey && e.key === 'ArrowUp')    { cloneSelected('up'); e.preventDefault(); }
    if (e.ctrlKey && e.key === 'ArrowDown')  { cloneSelected('down'); e.preventDefault(); }
    if (e.ctrlKey && e.key === 'ArrowLeft')  { cloneSelected('left'); e.preventDefault(); }
    if (e.ctrlKey && e.key === 'ArrowRight') { cloneSelected('right'); e.preventDefault(); }
  });

  console.log('[baseEditor] initHtmlExporter()');
  initHtmlExporter(exportBtn);
  console.log('[baseEditor] initInvestmentEditor()');
  initInvestmentEditor(Editor);

  editBtn.addEventListener('click', () => {
    const mode = !Editor.isEditing;
    Editor.setEditing(mode);
    document.body.contentEditable = mode;
    document.body.style.outline   = mode ? '2px dashed #0011FF' : '';
    editBtn.textContent           = mode ? 'Done' : 'Edit';
    [btnCloneUp,btnCloneDown,btnCloneLeft,btnCloneRight,btnDelete].forEach(b=>b.style.display = mode ? 'inline-block' : 'none');
    if (mode) document.body.addEventListener('click', selectHandler, true);
    else      { document.body.removeEventListener('click', selectHandler, true); clearSelection(); toolbar.style.display='none'; }
  });

  document.body.contentEditable = false;
  Editor.setEditing(false);
  console.log('[baseEditor] init done');
}

document.addEventListener('DOMContentLoaded', initBaseEditor);
